import { createContext, useContext } from "react";

export interface PaginationContext {
  enabled: boolean;
  page: number;
  rowsPerPage: number;
  rowsPerPageOptions: number[];
  setPage: (p: number) => any;
  setRowsPerPage: (rpp: number) => any;
}
const PaginationContext = createContext<PaginationContext>({
  enabled: false,
  rowsPerPageOptions: [5, 10, 25],
  rowsPerPage: 10,
  setRowsPerPage: (rpp: number) => null,
  page: 0,
  setPage: (p: number) => null,
});

export const usePagination = () => {
  return useContext(PaginationContext);
};
